module.exports = __webpack_public_path__ + "static/image/logo-family/logo_mart@2x.png?30f609b9";